import API from '../modules/api';
import { Controller } from 'stimulus';
import Mustache from 'mustache';
import UrlHandler from '../modules/urlhandler';

const api = new API({ authStoreKey: 'presentation-and-publications-filters' });
const URL = new UrlHandler();

const PARAMS = {
  limit: 6,
  offset: 0,
  from: URL.getParameter('from'),
  to: URL.getParameter('to'),
  keyword: URL.getParameter('keyword', 'string'),
  category: URL.getParameter('category', 'string')
}

let pagination = {};
let pages = 0;
let page = 0;

export default class extends Controller {
  static targets = [
    'list',
    'template',
    'to',
    'from',
    'keyword',
    'buttonContainer',
    'button',
    'paginationTemplate',
    'paginationContainer',
    'totalCount',
    'limit',
  ];

  /**
   * Automatically called when stimulus has initialized controller
   */
  initialize() {
    URL.addHandler(this.fromTarget);
    URL.addHandler(this.toTarget);
    URL.addHandler(this.keywordTarget);

    this.getData()
      .then(data => {
        if (typeof data.result !== 'undefined' && typeof data.result.files !== 'undefined' && data.result.files.length > 0) {
          this.render(this.listTarget, this.templateTarget, this._formatData(data));
        }
      });
    // this.updateButtons();
  }

  /**
   * Format data for mustache template
   * @param {array} data Array of XHR response to format
   * @return {array}
   */
  _formatData(data) {
    if (data.result.pagination) {
      pagination = data.result.pagination;
    }
    return Array.isArray(data.result.files) ?
      { items: data.result.files.map(item => {
        item.category = null;
        item.date = item.datePublishedFormatted;
        item.name = item.title;
        item.keywords = item.categoryName ? [{ name: item.categoryName }] : null;
        if (item.url) {
          item.image = item.thumbnail ? item.thumbnail : null;
          item.buttonLink = item.url ? item.url : null;
        } else {
          item.url = item.file?.url ? item.file.url : null;
          item.image = item.file?.thumbnail ? item.file?.thumbnail : null;
          item.buttonLink = item.file?.url ? item.file?.url : null;
        }
        item.buttonText = item.linkText ? item.linkText : null;
        item.contentTheme = 'dark';
        item.blank = true;
        return item;
      })} : null;
  }

  /**
   * Get data from api
   * @param {object} params parameters for api getBlogArticles
   * @returns {array} blog articles
   */
  getData(params = {}) {
    params = { ...PARAMS, to: (PARAMS.to.length > 0 ? PARAMS.to : null), from: (PARAMS.from.length > 0 ? PARAMS.from : null)};
    return api.getPresentationAndPublications(params);
  }

  /**
   * Update list (on select or input change)
   */
  updateList() {
    this.getData().then(data => {
      this.render(this.listTarget, this.templateTarget, this._formatData(data));
    });
  }

  /**
   * For selects, buttons etc.
   */
  inputHandler() {
    PARAMS.keyword = '';
    if (this.keywordTarget.value !== '') {
      PARAMS.keyword = this.keywordTarget.value;
      this.updateList();
    }
    if (this.toTarget.value !== '' && !PARAMS.to.includes(this.toTarget.value)) {
      PARAMS.to = this.toTarget.value;
      this.updateList();
      // this.updateButtons();
    }
    if (this.fromTarget.value !== '' && !PARAMS.from.includes(this.fromTarget.value)) {
      PARAMS.from = this.fromTarget.value;
      this.updateList();
      // this.updateButtons();
    }
  }

  /**
   * Update buttons to dom
   */
  updateButtons() {
    document.querySelectorAll('.btn[data-category]').forEach((button) => {
      button.classList.remove('btn--filter-primary');
    });
    if (document.querySelector('.btn[data-category="' + PARAMS.category + '"]')) {
      document.querySelector('.btn[data-category="' + PARAMS.category + '"]').classList.add('btn--filter-primary');
    }
  }

  /**
   * Clear all filters
   */
  clearFilters() {
    this.toTarget.value = '';
    this.fromTarget.value = '';
    this.keywordTarget.value = '';
    PARAMS.to = [];
    PARAMS.from = [];
    PARAMS.keyword = null;
    PARAMS.offset = 0;
    PARAMS.category = null;
    page = 0;
    this.updateList(true);
    this.updateButtons();
    URL.emptyParameters();
  }

  /**
   * Remove item from filters
   * @param {object} button element in page
   */
  removeFilter(button) {
    let type = button.currentTarget.getAttribute('data-type');
    let slug = button.currentTarget.getAttribute('data-slug');

    if (type === 'to') {
      this.toTarget.value = '';
      PARAMS.to = PARAMS.to.filter(item => item !== slug);
    } else if (type === 'topics') {
      this.fromTarget.value = '';
      PARAMS.from = PARAMS.from.filter(item => item !== slug);
    }

    PARAMS.offset = 0;
    page = 0;
    this.updateList(true);
    this.updateButtons();
    URL.removeParameter(type, slug);
  }

  toggleFilter(button) {
    let buttonCategory = button.currentTarget.getAttribute('data-category');
    PARAMS.category = buttonCategory;
    this.updateList(true);
    this.updateButtons();
  }

  /**
   * Change page from buttons in pagination
   * @param {object} button element
   */
  changePage(button) {
    let buttonPage = button.currentTarget.getAttribute('data-page');
    if (buttonPage === 'next') {
      if (page < pages-1) {
        page++;
      }
    } else if (buttonPage === 'previous') {
      if (page > 0) {
        page--;
      }
    } else {
      page = +buttonPage;
    }
    PARAMS.offset = page * PARAMS.limit;
    this.updateList(true);
  }

  updateLimit(button) {
    let buttonLimit = button.currentTarget.getAttribute('data-limit');
    if (buttonLimit <= 50 && buttonLimit >= 5) {
      PARAMS.limit = buttonLimit;
    }
    this.updateList(true);
  }

  /**
   * Render html to page
   * @param {object} target HTML selector
   * @param {object} html Element that inner html will be rendered
   * @param {object} data Data that will be used to rendered html
   */
  render(target, html, data) {
    if (pagination && pagination.totalCount > PARAMS.limit) {
      pages = Math.ceil(pagination.totalCount / PARAMS.limit);
      pagination.pages = [];
      for (let i = 0; i < pages; i++) {
        pagination.pages.push({
          active: page === i ? true : false,
          page: i,
          number: i + 1
        });
      }
      if (page === 0) {
        pagination.currentArticles = '1-' + (pagination.totalCount > PARAMS.limit ? PARAMS.limit : pagination.totalCount);
      } else if (page === pages-1) {
        pagination.currentArticles = page * PARAMS.limit + '-' + pagination.totalCount;
      } else {
        pagination.currentArticles = page * PARAMS.limit + '-' + ((page * PARAMS.limit) + PARAMS.limit)
      }
      this.paginationContainerTarget.innerHTML = Mustache.render(this.paginationTemplateTarget.innerHTML, { pagination });
    } else {
      this.paginationContainerTarget.innerHTML = Mustache.render(this.paginationTemplateTarget.innerHTML, { pagination: null });
    }

    target.innerHTML = '';
    if (data.items) {
      this.totalCountTarget.innerHTML = pagination.totalCount;
      this.limitTarget.innerHTML = pagination.limit;
      // target.innerHTML += Mustache.render(html.innerHTML, data);
      data.items.forEach((item) => {
        target.innerHTML += Mustache.render(html.innerHTML, item);
      });
    }
  }
}
